import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { CmxClientService } from '@cemex/cmx-client-layout';
import {
  OneClickLoadJobsiteSalesAreaAction,
  OneClickJobsiteSalesAreaActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-jobsite-sales-area.actions';
import { tap } from 'rxjs/operators';

@Injectable()
export class OneClickSalesAreaErrorEffects {
  // TODO: WIP CX018GO1905-832

  showNoSalesAreaError = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OneClickJobsiteSalesAreaActionTypes.SALES_AREA_ERROR),
        tap((action: OneClickLoadJobsiteSalesAreaAction) => {
          // FIXME: Prevent infinite loop
          // TODO: Show as modal?
          this.alertService.closeAllAlerts();
          this.alertService.addMainAlert('danger', this.translate.instant('views.one_click.sales_area_error'));
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private translate: TranslateService,
    private alertService: CmxClientService,
  ) {}
}
